import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as S from './SelectableChips.styles';
import Chip from '../Chip/Chip';
import Checkbox from '../Checkbox/Checkbox';
import P from '../Texts/Span/Span';

const filterActiveList = (list) =>
  list.filter(({ active, disabled }) => (disabled ? false : active)).length;

const SelectableChips = ({
  direction,
  options,
  onChange,
  multiSelect,
  selectAll,
  disabled,
}) => {
  const [list, setList] = useState(options);

  const handleOnClick = (text) => {
    let toggleActiveList = list.map((itemChip) => {
      let isItemSelected =
        (itemChip.value ? itemChip.value : itemChip.text) === text;
      if (multiSelect) {
        return isItemSelected
          ? { ...itemChip, active: !itemChip.active }
          : { ...itemChip };
      } else {
        return { ...itemChip, active: isItemSelected };
      }
    });
    setList(toggleActiveList);
    onChange(toggleActiveList);
  };

  const quantitySelected = filterActiveList(list);

  const handleSelectAll = () => {
    let toggleSelectAllList = list.map((itemChip) => {
      return {
        ...itemChip,
        active: itemChip.disabled ? false : quantitySelected === 0,
      };
    });
    setList(toggleSelectAllList);
    onChange(toggleSelectAllList);
  };

  const SelectAll = () => {
    return (
      <Checkbox
        id='select-all'
        checked={quantitySelected > 0}
        onChange={disabled ? undefined : handleSelectAll}
        isSelectAllCheck
        size='sm'
        disabled={disabled}
      >
        <P variant='neutral' modifier='strong' type='2' align='left'>
          {quantitySelected === 0 && 'Seleccionar todos'}
          {quantitySelected === 1 && `${quantitySelected} Seleccionado`}
          {quantitySelected > 1 && `${quantitySelected} Seleccionados`}
        </P>
      </Checkbox>
    );
  };

  useEffect(() => {
    setList(options);
  }, [options]);

  const chips = list.map((item) => {
    return (
      <S.ChipWrapper key={item.text}>
        <Chip
          active={item.active}
          text={item.text}
          value={item.value}
          onClick={item.disabled ? undefined : handleOnClick}
          disabled={item.disabled || disabled}
          tooltip={item.tooltip}
        />
      </S.ChipWrapper>
    );
  });

  return (
    <S.ChipsContainer>
      {multiSelect && selectAll && <SelectAll />}
      <S.SelectableChips direction={direction}>{chips}</S.SelectableChips>
    </S.ChipsContainer>
  );
};

SelectableChips.defaultProps = {
  direction: 'row',
  multiSelect: false,
  selectAll: false,
  disabled: false,
};

SelectableChips.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      /** REQUERIDO: valor del chip */
      value: PropTypes.string,
      /** REQUERIDO: texto del chip */
      text: PropTypes.string,
      /** REQUERIDO: estado del chip */
      active: PropTypes.bool,
      /** OPCIONAL: deshabilitar el chip. esto evita que pueda ser seleccionado y no puede ser seleccionado por selectAll */
      disabled: PropTypes.bool,
    })
  ).isRequired,
  /** OPCIONAL: disposición visual de los chips.*/
  direction: PropTypes.oneOf(['row', 'column']),
  /** OPCIONAL: paso de método a ejecutar por trigger change.*/
  onChange: PropTypes.func,
  /** OPCIONAL: habilitar la multiple selección de chips.*/
  multiSelect: PropTypes.bool,
  /** OPCIONAL: habilitar la selección de todos los chips. esto REQUIERE propiedad [multiSelect] */
  selectAll: PropTypes.bool,
  /** OPCIONAL: deshabilitar todos los chips. esto evita que puedan ser seleccionados y deshabilita el método selectAll */
  disabled: PropTypes.bool,
};

export default SelectableChips;
